import { Icon } from './Icon';

type Props = {
  leftIcon: string;
  rightIcon: string;
  className?: string;
};

export const DialogRightCornerIcons = ({ leftIcon, rightIcon, className }: Props) => {
  return (
    <div className={`md:flex hidden items-center justify-center absolute -top-4.5 -right-3.5 ${className}`}>
      <div className="-rotate-12">
        <div className="size-10 flex items-center justify-center border-4 border-gray-200 rounded-lg bg-white">
          <Icon name={leftIcon} className="size-5" />
        </div>
      </div>
      <div className="rotate-12 z-10 -ml-2">
        <div className="size-10 flex items-center bg-white justify-center border-4 border-gray-200 rounded-lg">
          <Icon name={rightIcon} className="size-5" />
        </div>
      </div>
    </div>
  );
};
